import PropTypes from 'prop-types';
import React from 'react';

import AddressViewField from '@department-of-veterans-affairs/platform-forms-system/AddressViewField';

import { formatDate } from '../../shared/utils/dates';

const EffectiveDateViewField = ({ formData }) => {
  const { from, to } = formData;
  const dateFormat = 'MMM D, YYYY';
  const addMonthPeriod = str =>
    (str || '').replace(
      /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) /,
      '$1. ',
    );
  const fromDateString = from
    ? addMonthPeriod(formatDate(from, dateFormat))
    : '';
  const toDateString = to ? addMonthPeriod(formatDate(to, dateFormat)) : '';
  return to ? (
    <p>
      We’ll use this address starting on {fromDateString} until {toDateString}:
    </p>
  ) : (
    <p>We’ll use this address starting on {fromDateString}:</p>
  );
};

EffectiveDateViewField.propTypes = {
  formData: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
  }),
};

export const ForwardingAddressViewField = ({ formData }) => {
  const { effectiveDate } = formData;
  return (
    <div>
      <EffectiveDateViewField formData={effectiveDate} />
      <AddressViewField formData={formData} />
    </div>
  );
};
ForwardingAddressViewField.propTypes = {
  formData: PropTypes.shape({
    effectiveDate: PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string,
    }),
  }),
};

export const forwardingAddressDescription = () => (
  <p>
    If you give us a temporary or forwarding address, we’ll look at the dates
    you provide to see if we need to use this address when scheduling any exams.
  </p>
);

export {
  contactInfoDescription,
  contactInfoUpdateHelpDescription,
} from '../../shared/components/contactInfoDescriptions';
